<template>
  <el-dialog :visible.sync="dialogVisible" width="400px" :before-close="skip" :close-on-click-modal="false">
    <div class="container">
      <div class="box">
        <ul class="tab">
          <li class="on">推广码</li>
        </ul>

        <el-input
          v-model.trim="iCode"
          class="check-inp"
          maxlength="11"
          name="iCode"
          placeholder="请填写推广码"
        />

        <el-button class="btn-blue btn-sure" @click="sure">确定</el-button>

        <el-button class="btn-skip" @click="skip">跳过</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import userInfo from '@/mixins/userInfo'
import Cookie from "js-cookie"

export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      iCode: Cookie.get('iCode') || '',
      dialogVisible: false,
    }
  },

  mixins: [userInfo],

  watch: {
    value() {
      this.dialogVisible = this.value
    }
  },
  methods: {
 
    sure() {
      if (!this.iCode) {
        this.$message.error('请填写推广码')
        return
      }
      //  this.getPopupInfo();
      console.log( this.$store.state)
      this.$emit('regist',this.iCode)
      const obj = {
        uid: this.$store.state.login.loginId,
        invitedcode: this.iCode
      }
      this.axios
        .post('/api-user/users-comm/saveInvitedCode', obj)
        .then(res => {
          if (res.resp_code == 200) {
            // this.$emit('handle')
            this.getPopupInfo();
          } else {
            this.$message.error(res.resp_msg)
          }
        })
    },
    skip() {
      this.$emit('handle')
      this.$emit('input', false)
    },
    //获取弹窗信息
    getPopupInfo(){
      this.axios
        .post('/api-personal/laozi/v3/common/unauth/getPopupSettings')
        .then(res => {
          if (res.resp_code == 60000) {
            this.popupStatus=res.datas.status;
            if(this.popupStatus==1){
              this.$emit('handle');
            }else if(this.popupStatus==0){
               this.goReturnUrl()
            }
            
          } else {
            this.$message.error(res.resp_msg)
          }
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  .box {
    width: 400px;
    background: #fff;
    // height: 630px;
    box-sizing: border-box;
    position: relative;
    text-align: center;
    .icon-guanbi {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 18px;
      padding: 10px;
      color: #8192a8;
      cursor: pointer;
      &:hover {
        color: #0055f3;
      }
    }

    .tab {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      border-bottom: 1px solid #e4e9f3;
      li {
        width: 97px;
        height: 27px;
        cursor: pointer;
        line-height: 27px;
        color: #132c4b;
        font-size: 24px;
        padding-bottom: 30px;
        border-bottom: 4px solid transparent;
      }
      .on {
        border-color: #0055f3;
      }
    }

    .check-inp {
      width: 320px;
      margin-top: 40px;
    }

    .btn-sure {
      display: block;
      margin: 60px auto 40px;
      width: 200px;
      height: 50px;
      border-radius: 25px;
      /deep/ span {
        font-size: 16px;
      }
    }

    .btn-skip {
      display: block;
      margin: 0 auto;
      border: none;
      /deep/ span {
        font-size: 16px;
      }
    }
    .btn-skip:hover,
    .btn-skip:focus {
      background-color: #fff;
      color: #606266;
    }
  }
}

.btn-blue {
  background: #1458ea;
  border: none;
  color: #ffffff;
  transition: all 0.2s linear;
}

.btn-blue:focus,
.btn-blue:hover {
  color: #ffffff;
  border-color: #1458ea;
  background-color: rgba(20, 88, 234, 0.8);
}
</style>
